import { c as _c } from "react/compiler-runtime";
import { Form, FormikErrors, FormikTouched } from 'formik';
import FormGroupComponent, { InputType } from '../../form-group/form-group.component';
import React, { ReactElement } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { WishlistFormFields } from '@spa/components/forms/wishlist-form/wishlistFormTypes';
import styles from './wishlist-form.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly errors: FormikErrors<WishlistFormFields>;
  readonly touched: FormikTouched<WishlistFormFields>;
  readonly values: WishlistFormFields;
  readonly isSubmitting?: boolean;
}
function WishlistFormComponent(t0) {
  const $ = _c(19);
  const {
    errors: t1,
    touched: t2,
    values: t3,
    isSubmitting
  } = t0;
  const {
    name: nameError,
    description: descriptionError
  } = t1;
  const {
    name: nameTouched,
    description: descriptionTouched
  } = t2;
  const {
    name,
    description
  } = t3;
  const {
    formatMessage
  } = useNamespacedIntl("add-wishlist");
  let t4;
  if ($[0] !== formatMessage) {
    t4 = formatMessage("fields.name");
    $[0] = formatMessage;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== isSubmitting || $[3] !== name || $[4] !== nameError || $[5] !== nameTouched || $[6] !== t4) {
    t5 = <FormGroupComponent id="wishlist-form" label={t4} name="name" touched={nameTouched} error={nameError} value={name} type={InputType.TEXT} isDisabled={isSubmitting} required={true} />;
    $[2] = isSubmitting;
    $[3] = name;
    $[4] = nameError;
    $[5] = nameTouched;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== formatMessage) {
    t6 = formatMessage("fields.description");
    $[8] = formatMessage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== description || $[11] !== descriptionError || $[12] !== descriptionTouched || $[13] !== isSubmitting || $[14] !== t6) {
    t7 = <FormGroupComponent id="wishlist-form" label={t6} name="description" touched={descriptionTouched} error={descriptionError} value={description} type={InputType.TEXT} isDisabled={isSubmitting} />;
    $[10] = description;
    $[11] = descriptionError;
    $[12] = descriptionTouched;
    $[13] = isSubmitting;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <Form className={styles["wishlist-form"]}>{t5}{t7}</Form>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default WishlistFormComponent;